// Content for the Expérience numérique « Le défi » section.
export type Bi = { fr: string; en: string }

export const ATNA_LOGO = 'https://cdn.magicpatterns.com/uploads/d6cqpG2SGUofNqC1hEedXv/Logo_ATNA_(5).png'

export const dxChallengeCopy = {
  eyebrow: { fr: 'Le défi', en: 'The challenge' },
  navy: [
    { fr: 'Vos usagers ne chercheront', en: 'Your users won’t just look' },
    { fr: 'plus seulement une page.', en: 'for a page anymore.' },
  ] as Bi[],
  indigo: [
    { fr: 'Ils demanderont qu’on', en: 'They’ll ask for help' },
    { fr: 'les aide à agir.', en: 'to get things done.' },
  ] as Bi[],
  body: {
    fr: 'La façon d’accéder aux services change. Les usagers passent de la navigation à la conversation — et s’attendent à obtenir des réponses fiables et à accomplir leurs démarches, partout et simplement.',
    en: 'The way people access services is changing. Users are moving from browsing to conversation — and expect reliable answers and an easy way to get things done, wherever they are.',
  },
}

// External Gartner market indicators — not BCITI | ATNA results.
export const dxMarketStats: { value: Bi; text: Bi; source: Bi }[] = [
  {
    value: { fr: '51 %', en: '51%' },
    text: { fr: 'des parcours de service commencent déjà sur une plateforme tierce.', en: 'of service journeys already start on a third-party platform.' },
    source: { fr: 'Gartner, 2025', en: 'Gartner, 2025' },
  },
  {
    value: { fr: '3×', en: '3×' },
    text: { fr: 'plus de chances que les usagers utilisent une IA générative tierce plutôt qu’un robot conversationnel fourni par l’organisation.', en: 'more likely that users will turn to a third-party generative AI than to a chatbot provided by the organization.' },
    source: { fr: 'Gartner, 2026', en: 'Gartner, 2026' },
  },
  {
    value: { fr: '70 %', en: '70%' },
    text: { fr: 'des parcours de service pourraient commencer et être résolus dans des assistants conversationnels tiers d’ici 2028.', en: 'of service journeys could start and be resolved in third-party conversational assistants by 2028.' },
    source: { fr: 'Gartner (prévision pour 2028)', en: 'Gartner (2028 forecast)' },
  },
]

export type EntryKey = 'web' | 'app' | 'portal' | 'llm'

export const dxEntries: { key: EntryKey; label: Bi; text: Bi }[] = [
  { key: 'web', label: { fr: 'Site Web', en: 'Website' }, text: { fr: 'Découvrir, comprendre et faire une demande', en: 'Discover, understand and make a request' } },
  { key: 'app', label: { fr: 'App mobile', en: 'Mobile app' }, text: { fr: 'Accéder, recevoir, signaler et agir', en: 'Access, receive, report and act' } },
  { key: 'portal', label: { fr: 'Portail', en: 'Portal' }, text: { fr: 'S’identifier et gérer vos services', en: 'Sign in and manage your services' } },
  { key: 'llm', label: { fr: 'LLM / assistants IA', en: 'LLM / AI assistants' }, text: { fr: 'Poser une question en langage naturel', en: 'Ask a question in natural language' } },
]

export const dxLlm = {
  intent: { fr: 'Je veux installer une piscine.', en: 'I want to install a pool.' },
  assistants: ['ChatGPT', 'Gemini', 'Copilot'],
  questions: [
    { fr: 'Quels sont les règlements dans ma ville ?', en: 'What are the rules in my city?' },
    { fr: 'Quel permis est requis ?', en: 'Which permit is required?' },
    { fr: 'Je veux signaler un nid-de-poule.', en: 'I want to report a pothole.' },
    { fr: 'Quelles activités ont lieu cette fin de semaine ?', en: 'What activities are on this weekend?' },
  ] as Bi[],
}

export const dxAtnaLayer = {
  ask: { fr: 'Demander à ATNA…', en: 'Ask ATNA…' },
  verbs: { fr: 'Comprend · Vérifie · Recommande · Orchestre · Agit', en: 'Understands · Verifies · Recommends · Orchestrates · Acts' },
}

export type YesterdayKey = 'search' | 'form' | 'system' | 'wait'
export type TomorrowKey = 'ask' | 'understand' | 'identify' | 'verify' | 'prepare' | 'pay' | 'track'

export const dxYesterday = {
  label: { fr: 'Hier', en: 'Yesterday' },
  sub: { fr: 'Naviguer d’un point A à un point B', en: 'Navigating from point A to point B' },
  steps: [
    { key: 'search', label: { fr: 'Chercher une page', en: 'Search for a page' } },
    { key: 'form', label: { fr: 'Trouver un formulaire', en: 'Find a form' } },
    { key: 'system', label: { fr: 'Changer de système', en: 'Switch systems' } },
    { key: 'wait', label: { fr: 'Attendre un suivi', en: 'Wait for follow-up' } },
  ] as { key: YesterdayKey; label: Bi }[],
}

export const dxTomorrow = {
  label: { fr: 'Demain', en: 'Tomorrow' },
  sub: { fr: 'Demander en langage naturel et obtenir un résultat', en: 'Ask in natural language and get a result' },
  steps: [
    { key: 'ask', label: { fr: 'Demander', en: 'Ask' } },
    { key: 'understand', label: { fr: 'Comprendre', en: 'Understand' } },
    { key: 'identify', label: { fr: 'Identifier', en: 'Identify' } },
    { key: 'verify', label: { fr: 'Vérifier', en: 'Verify' } },
    { key: 'prepare', label: { fr: 'Préparer', en: 'Prepare' } },
    { key: 'pay', label: { fr: 'Payer', en: 'Pay' } },
    { key: 'track', label: { fr: 'Suivre', en: 'Track' } },
  ] as { key: TomorrowKey; label: Bi }[],
}
